(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-1"] && !Shopify.designMode) return;
  try {
    
<!-- Evt. custom JS kan tilføjes her -->

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog1-omvendt"] && !Shopify.designMode) return;
  try {
    
<!-- Evt. custom JS kan tilføjes her -->

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-blog-2"] && !Shopify.designMode) return;
  try {
    
<!-- Evt. custom JS, hvis ønsket -->

  } catch(e) { console.error(e); }
})();
})();
